import { BkRoutes } from 'bkng';

import { id } from './id/id';

export const domain: BkRoutes = [
    {
        path: "id",
        label: "Domain by ID",
        children: id,
    },
];
